import styled from 'styled-components';
export const LoadingCentered = styled.div.withConfig({
  displayName: "Loadingstyles__LoadingCentered",
  componentId: "sc-1xfyb1d-0"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;max-height:350px;"]);